module.exports = __webpack_public_path__ + "img/img05_text.4158f583.png";